import { useState } from "react";

const LimitedTextContainer = ({ text }) => {
  const [showMore, setShowMore] = useState(true);
  const [maxLines, setMaxLines] = useState(0);
  const getNumberOfLines = (element) => {
    const styles = window.getComputedStyle(element);
    const lineHeight = parseInt(styles.lineHeight);
    const height = parseInt(styles.height);
    const numberOfLines = Math.round(height / lineHeight);
    if (maxLines === 0) {
      setMaxLines(numberOfLines);
    }
  };

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      <div
        className={`description ${showMore ? "show-all" : ""}`}
        ref={(el) => {
          if (el) {
            getNumberOfLines(el);
          }
        }}
      >
        <p className="fs-16 medium p-0">{text}</p>
      </div>
      {maxLines > 2 && (
        <div>
          <span className="color-main-blue cp bold" onClick={toggleShowMore}>
            {showMore ? "Show Less" : "Show More"}
          </span>
        </div>
      )}
    </>
  );
};

export default LimitedTextContainer;
